<template>
      <div class="table-search-wrap">
      <div class="wrap-input">
        <input
          v-model="search"
          @input="mainSearch(1, 20)"
          type="search"
          class="table-search"
          placeholder="Search in resources..." />
      </div>
      <div class="wrap-search-icon">
        <icon name="search"></icon>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'searchInArticles',
    data: function () {
      return {
        search: ''
      }
    }
  }
</script>

<style></style>










// WEBPACK FOOTER //
// searchInArticles.vue?22d7bb3c